import * as angular from "angular";

angular
  .module('bringoz.admin.admins')
  .filter('accountKey', accountKey);

/* @ngInject */
function accountKey() {
  return function (accountKey) {
    const string = 'serviceAccount:';
    const stringIndex = accountKey.search(string);

    return stringIndex !== -1 ? accountKey.slice(string.length, accountKey.length) : accountKey;
  }
}
